import React from 'react';
import styled from 'styled-components';
import { H3 } from '../../../Atoms/Typo';

const Component = styled.div`
  margin-bottom: 10px;
`;

interface CardHeaderProps {
  className?: string;
  title: string;
}

const CardHeader = ({ title, className }: CardHeaderProps) => {
  return (
    <Component className={className}>
      <H3>{title}</H3>
    </Component>
  );
};

export default CardHeader;
